export const formatINR = (val) => {
  const n = Number(val || 0);
  return new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 }).format(n);
};

export const formatINR2 = (val) => {
  const n = Number(val || 0);
  return new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR" }).format(n);
};

export const fmtDate = (s) => {
  if (!s) return "—";
  try {
    return new Date(s).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
  } catch (e) { return s; }
};

export const today = () => new Date().toISOString().slice(0, 10);

export const statusTone = (s) => {
  const t = (s || "").toLowerCase();
  if (["paid", "won", "completed", "active"].includes(t)) return "bg-emerald-50 text-emerald-700 border-emerald-200";
  if (["partial", "negotiation", "proposal", "proposal sent", "meeting scheduled", "interested"].includes(t)) return "bg-amber-50 text-amber-700 border-amber-200";
  if (["overdue", "lost", "on hold", "closed"].includes(t)) return "bg-rose-50 text-rose-700 border-rose-200";
  if (["draft", "new", "attempting contact", "contacted"].includes(t)) return "bg-slate-50 text-slate-700 border-slate-200";
  return "bg-[#fef7ee] text-[#9a7430] border-[#e8d1a3]";
};
